import React, { Component } from "react";

export class NoticiasContent extends Component {
  state = {

  } 

  contenidoPub = () => {
    return (
      <div dangerouslySetInnerHTML={ { __html: this.props.content } }></div>
    )
  }

  render() {
    
    return (
      <div className="card card-user" style={{boxShadow: "1px 1px 2px #CCC", backgroundColor:"#fbfbfb"}}>
        <div className="content" style={{minHeight:0, lineHeight:2}} align="justify">
          <div className="custom-alert-info"><i className="pe-7s-news-paper"></i> {this.props.titulo}</div>
          <div className="custom-mt-10" style={{padding:10}}>
            {this.contenidoPub()}
          </div>
        </div>
        <hr />
        <div style={{padding:5, color:"#999", fontSize: 11,}} className="row">
          <div className="col-lg-8">
            Publicado por <span style={{fontWeight: "bold"}}>{this.props.autor}</span> | <i className="pe-7s-timer"></i> {this.props.fecha}
          </div>
          <div className="col-lg-4" align="right" title={`${this.props.comentarios} comentarios`}>
            {/* <i className="pe-7s-comment"></i> {this.props.comentarios} */}
          </div>
        </div>
      </div>
    );
  }
}

export default NoticiasContent;



// WEBPACK FOOTER //
// ./src/components/NoticiasContent/NoticiasContent.jsx